import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'liberro-back-button',
  standalone: false,
  templateUrl: './liberro-back-button.component.html',
  styleUrl: './liberro-back-button.component.less'
})
export class LiberroBackButtonComponent {

  @Input() public top = '30px';
  @Input() public left = '-82px';
  @Input() public right = 'unset';
  @Input() public dataCy = '';
  @Input() public partOfHeaderSection = false;
  @Output() public backBtnClick = new EventEmitter<void>();

  public handleClick(): void {
    this.backBtnClick.emit();
  }

}
